if (!window.ucwComparisonOriginalZoomReady) {
    window.ucwComparisonOriginalZoomReady = true;

    document.addEventListener('click', (event) => {
      const comparisonButton = event.target.closest(
        '[data-uw-comparison-original-open]'
      );

      if (!comparisonButton) return;

      const imageIndex =
        comparisonButton.dataset.originalImageIndex || '0';

      const originalPopupButton = document.querySelector(
        `[data-original-image-open][data-original-image-index="${imageIndex}"]`
      );

      originalPopupButton?.click();
    });
  }
